exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  font-family: Roboto, arial, sans-serif;\n  font-size: 12px;\n  font-weight: 300;\n  color: #4a4a4a;\n  background-color: rgb(250, 250, 250);\n  padding: 0;\n  margin: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/index.css
// module id = 339
// module chunks = 0